import { render, staticRenderFns } from "./procedures-list.vue?vue&type=template&id=6e99eef0"
import script from "./procedures-list.vue?vue&type=script&lang=js"
export * from "./procedures-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports